"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getHeaders = void 0;
const getHeaders = (getToken) => ({
    Authorization: getToken(),
    'Content-Type': 'application/json'
});
exports.getHeaders = getHeaders;
//# sourceMappingURL=ajax.js.map